module.exports = __webpack_public_path__ + "img/22_17.02bc6139.png";